<template>
    <el-dialog 
    :modal-append-to-body="false"
    :title="'绑定电子邮箱'"
    :visible.sync="visible"
    width="600px"
    :before-close="handleClose"
    custom-class="customModal">
    <el-form :model="form"  :rules="rules" ref="form" label-width="100px" style="padding: 0px 15px 0 4px">
        <el-form-item label="旧邮箱" prop="old_email">
            <el-input v-model="form.old_email" auto-complete="off" />
        </el-form-item>
        <el-form-item label="验证码" prop="codeCode" v-if="verificationCodeShow">
            <el-input v-model="form.codeCode" auto-complete="off"></el-input>
            <img :src="img_src" class="verificationIMG" alt="点击刷新图片" @click="reflash" style="width: 289px;height:80px;margin: 10px 0 0 10px;"/>
            <el-button type="primary" class="fr sendVerification" style="float:left;margin-top:50px;" @click="smsCodeSend" v-text="expirationDate==='due'?'请等待' + '(' + timerData + ')':'发送验证码'" :disabled="expirationDate==='due'"></el-button>
        </el-form-item>
        <el-form-item label="邮箱验证码" prop="emailCode">
            <el-input type="text" v-model="form.emailCode" auto-complete="off" />
        </el-form-item>
        <el-form-item label="新邮箱" prop="email">
            <el-input v-model="form.email" auto-complete="off" />
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">提交</el-button>
        <el-button @click="close">重置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { UserCenterService } from '../../../service/userCenter.service'
import { LoginService } from "../../../service/login.service";
import cookie from 'vue-cookies'
import Axios from 'axios'

  export default {
    data() {
       var checkemail = (rule, value, callback) => {
        if (!value) {
            return callback(new Error('邮箱地址不能为空'));
        } else {
            const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
            if (reg.test(value)) {
                callback();
            } else {
                return callback(new Error('请输入正确的邮箱地址'));
            }
        }
      }
      return {
        img_src: '',
        old_mobile: '',
        visible: false,
        timerData: 60,
        verificationCodeShow: true,
        expirationDate: cookie.get('expirationDateEmail'),
        form: {
            email: '',
            tag: 'email',
            emailCode: '',
            codeCode: '',
            model: 'emailChange',
            old_email: ''
        },
        rules: {
          codeCode:[
            { required:true,message: '请输入验证码',trigger: 'blur' },
          ],
          emailCode: [
            { required: true,message: '请输入邮箱验证码', trigger: 'blur' },
          ],
          email: [
            { required: true,validator: checkemail, trigger: 'blur' },
          ],
          old_email: [
            { required: true,validator: checkemail, trigger: 'blur' },
          ]
        },
      }
    },
    watch: {
        timerData(newV) {
            return newV
        }
    },
    methods: {
      async open() {
        this.visible = true;
        this.reflash()
        this.timer()
      },
      async submit() {
          if(this.$refs.form.validate()) {
              const data = await UserCenterService.changeEmailOrMobile({
                tag:'email',
                email:this.form.old_email,
                newemail:this.form.email,
                emailCode:this.form.emailCode
              })
              this.$emit('submitSuccess',data.data)
              this.close();
          }
      },
      reflash() {
        var url = 'https://api.goodyiyao.cn/web/other/digitalVerificationCode?model=codeSend'
        let that = this
        Axios.get(url,{ responseType: 'arraybuffer',withCredentials: true}).then(function(res){
          let codeImg =  'data:image/png;base64,' + btoa(
          new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
          that.img_src = codeImg
        })
      },
      async smsCodeSend() {
        await LoginService.setCheckNumber({
          type:'email',
          account:this.form.old_email,
          model:'codeSend',
          code_num:this.form.codeCode,
          status:1,
          access_token:localStorage.getItem('token')
        }).then(()=>{
          this.verificationCodeShow = false
        })
      },
      timer() {
        let setTimeout =  cookie.get('changeEmailStart_time')
        let newDate = 60 - (parseInt(Number(new Date())/1000) - parseInt(setTimeout/1000))
        let timer = setInterval(()=>{
            if(newDate > 0 ){newDate -- ;this.timerData = newDate}
            else {clearInterval(timer);this.expirationDate = cookie.get('expirationDateEmail')}
        },1000)
      },
      close() {
        this.form = {}
        this.visible = false
        this.verificationCodeShow = true
      },
      handleClose() {
        this.close()
      }
    },
    created() {
    
    }
  }
</script>

<style lang="scss">
  .formItemFill .el-dialog__wrapper{
    z-index: 2500!important;
  }
  .rotationChart{
    .el-dialog__wrapper{
      .upload.formItemFill{
        height: 8vw;
        position: relative;
        .el-upload-list__item{
          margin-top: 0;
        }
        .el-button{
          position: absolute;
          top: 0px;
          left: 120px;
        }
      }
      .bg_color.formItemFill{
        height: 8vw;
        .el-color-picker__trigger{
          width: 100%;
          height: 93px;
          margin-top: -3px;
          .el-color-picker__icon{
            display: none;
          }
        }
      }
    }
  }
  .imgBox{
    text-align: left;
    border: 1px solid #e6e6e6;
    height: 6.2vw;
    img{
      height: 6.2vw;
    }
  }
</style>